const init = () => {
	$(document).ready(function() {
	    // add work quota
	    $('.add-work-quota').on('click', function(e) {
	        e.preventDefault();
	        var container = $('.work-quota-prototype-container');
	        var uuid = parseInt(Math.random() * Math.floor(9899) + 100);
	        var proto = container.data('prototype').replace(/__NAME__/g, uuid);
	        container.find('.work-quota-container').append(proto);

	        container.find(`[name="workQuotas[${uuid}][work_quota]"]`).focus();
	    });

	    // remove work quota
	    $(document).on('click', '.remove-work-quota', function(){
	        var container = $(this).closest('.form-group');
	        container.remove();
	    });
	});
}

export default init;